module.exports = __webpack_public_path__ + "static/img/pic_girl.1eb020f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_girl.png
// module id = ux6b
// module chunks = 1